<template>
  <div class="application-list-item">
    <!--标题-->
    <div class="title">
      <span>
        <van-icon
          name="home"
          size="24px"
          class-prefix="iconfont"
        />
        {{ applicationInfo.businessTypeAlias }}
      </span>
      <van-tag :type="applicationInfo.status|applicationStatusTagType">
        {{ applicationInfo.status|applicationStatusName }}
      </van-tag>
    </div>
    <!--详情-->
    <van-cell-group
      :border="false"
      class="detail"
    >
      <van-cell
        title="申请事项"
        :value="applicationInfo.registrationItemAlias"
        :border="false"
      >
        <van-icon
          slot="icon"
          name="product"
          size="20px"
          class-prefix="iconfont"
          class="van-cell__left-icon"
        />
      </van-cell>
      <van-cell
        title="申请单号"
        :value="applicationInfo.businessNo"
        :border="false"
      >
        <van-icon
          slot="icon"
          name="order"
          size="20px"
          class-prefix="iconfont"
          class="van-cell__left-icon"
        />
      </van-cell>
      <van-cell
        title="申请信息"
        :border="false"
      >
        <van-icon
          slot="icon"
          name="ipad"
          size="20px"
          class-prefix="iconfont"
          class="van-cell__left-icon"
        />
        <span
          slot="label"
          class="application-info"
        >
          <div class="application-info-cell">
            <span class="application-info-cell__title">申请人</span>
            <span class="application-info-cell__value">{{ applicationInfo.applicantName }}</span>
          </div>
          <div class="application-info-cell">
            <span class="application-info-cell__title">申请时间</span>
            <span class="application-info-cell__value">{{ applicationInfo.applicationTime | dateTime }}</span>
          </div>
          <div class="application-info-cell">
            <span class="application-info-cell__title">申请备注</span>
            <span class="application-info-cell__value">{{ applicationInfo.remark || '无' }}</span>
          </div>
        </span>
      </van-cell>
      <van-cell
        v-if="applicationInfo.status>1"
        title="受理信息"
        :border="false"
      >
        <van-icon
          slot="icon"
          name="suggest"
          size="20px"
          class-prefix="iconfont"
          class="van-cell__left-icon"
        />
        <span
          slot="label"
          class="application-info"
        >
          <div class="application-info-cell">
            <span class="application-info-cell__title">受理人</span>
            <span class="application-info-cell__value">{{ applicationInfo.acceptorName }}</span>
          </div>
          <div class="application-info-cell">
            <span class="application-info-cell__title">受理时间</span>
            <span class="application-info-cell__value">{{ applicationInfo.acceptTime| dateTime }}</span>
          </div>
          <div class="application-info-cell">
            <span class="application-info-cell__title">受理意见</span>
            <span class="application-info-cell__value">{{ applicationInfo.acceptOpinion }}</span>
          </div>
        </span>
      </van-cell>
    </van-cell-group>
    <!--按钮-->
    <div class="buttons">
      <van-button
        type="default"
        size="small"
        round
        :to="{name:'ApplicationProcess',params:{id:applicationInfo.id}}"
      >
        办理过程
      </van-button>
      <van-button
        :type="applicationInfo.status|applicationStatusButtonType"
        size="small"
        round
        :to="{name:'ViewApplication',params:{id:applicationInfo.id}}"
      >
        申请详情
      </van-button>
      <van-button
        v-if="isUnsubmitted"
        :type="applicationInfo.status|applicationStatusButtonType"
        size="small"
        round
        :to="{name:'UpdateApplication',params:{id:applicationInfo.id}}"
      >
        去提交
      </van-button>
      <van-button
        v-if="isCorrection"
        :type="applicationInfo.status|applicationStatusButtonType"
        size="small"
        round
        :to="{name:'UpdateApplication',params:{id:applicationInfo.id}}"
      >
        补正
      </van-button>
    </div>
  </div>
</template>

<script>
import { ApplicationStatus } from '@/utils/enums.js'
import { formatDate } from '@/utils'

export default {
  filters: {
    dateTime: function(dateString) {
      return formatDate(new Date(dateString), 'yyyy-MM-dd hh:mm:ss')
    },
    applicationStatusName: function(status) {
      return ApplicationStatus.getTextByValue(status)
    },
    applicationStatusTagType: function(status) {
      switch (status) {
        case ApplicationStatus.Unsubmitted.value:
          return 'default'
        case ApplicationStatus.Pending.value:
          return 'primary'
        case ApplicationStatus.Accepted.value:
          return 'success'
        case ApplicationStatus.Correction.value:
          return 'warning'
        case ApplicationStatus.Refused.value:
          return 'danger'
        default:
          return 'default'
      }
    },
    applicationStatusButtonType: function(status) {
      switch (status) {
        case ApplicationStatus.Unsubmitted.value:
          return 'default'
        case ApplicationStatus.Pending.value:
          return 'info'
        case ApplicationStatus.Accepted.value:
          return 'primary'
        case ApplicationStatus.Correction.value:
          return 'warning'
        case ApplicationStatus.Refused.value:
          return 'danger'
        default:
          return 'default'
      }
    }
  },
  props: {
    applicationInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
    }
  },
  computed: {
    isUnsubmitted() {
      return this.applicationInfo.status === ApplicationStatus.Unsubmitted.value
    },
    isCorrection() {
      return this.applicationInfo.status === ApplicationStatus.Correction.value
    }
  }
}
</script>

<style scoped lang="scss">
.application-list-item {
  margin: 10px 10px 0px 10px;
  padding: 10px;
  font-size: 15px;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 2px 3px #bcbcbc;
  .title {
    color: #333;
    widows: 100%;
    line-height: 24px;
    font-weight: 700;
    .iconfont{
      vertical-align: -3px;
    }
    .van-tag{
      float: right;
    }
  }
  .detail{
    .application-info{
      display: block;
      padding: 10px;
      background-color: #F7F7F7;
      border-radius: 4px;
      .application-info-cell{
        height: 24px;
        line-height: 24px;
        .application-info-cell__title{
          color: #333;
        }
        .application-info-cell__value{
          float: right;
        }
      }
    }
  }
  .buttons{
    text-align: right;
    .van-button{
      margin-left:10px;
    }
  }
}
</style>
